/* Progressive enhancement only. No product visibility, filter or cart mutations. */
(() => {
  'use strict';
  const root = document.querySelector('#main-content.bd-department');
  if (!root) return;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  try { paused = localStorage.getItem('byards-atmosphere-paused') === 'true'; } catch (_) { /* Storage is optional. */ }
  function apply() {
    root.classList.toggle('bd-atmosphere-ready', !preference.matches && Boolean(root.querySelector('[data-bd-motion-toggle]')));
    root.classList.toggle('bd-motion-paused', paused || preference.matches || document.hidden);
    root.querySelectorAll('[data-bd-motion-toggle]').forEach(button => {
      button.hidden = preference.matches;
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? 'Resume gentle atmosphere' : 'Pause gentle atmosphere';
    });
  }
  function initialise(scope) {
    scope.querySelectorAll('[data-bd-motion-toggle]').forEach(button => {
      if (button.dataset.bdReady) return;
      button.dataset.bdReady = 'true';
      button.addEventListener('click', () => {
        paused = !paused;
        try { localStorage.setItem('byards-atmosphere-paused', String(paused)); } catch (_) { /* Optional. */ }
        apply();
      });
    });
    apply();
  }
  if (preference.addEventListener) preference.addEventListener('change', apply);
  document.addEventListener('visibilitychange', apply);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  initialise(root);
})();
